module.exports = __webpack_public_path__ + "static/unlimited-pto-ad316385eecbf75596051eb7b248cbf5.png";